import React, { useRef, useState } from 'react'

const Video = () => {
    const video = useRef(null)
    const [play, setPlay] = useState(false)

    const onClickPlay = () => {
        if (play) {
            video.current.pause()
            setPlay(!play)
        } else {
            video.current.play()
            setPlay(!play)
        }
    }
    return (
        <div className="wrapper__video-wrap testimoni position-relative my-4">
            <img src="./../images/Play (1).png" className="pointer play" onClick={() => onClickPlay()} alt="" />

            <video ref={video} width="320" poster="./../images/image 5.png" height="240" controls>
                <source src="./../images/03_oduvan_agro_hand_14_dut_oduvan_preview.mp4" type="video/mp4" />
            </video>
        </div>
    )
}

export default Video